export const getPartnerList = async () => {
    try {
        const url = `${process.env.API_BASE_URL}/partners/list`;
        const response = await fetch(url, {
            method: "GET",
            /* headers: {
                "X-product": "orobonds:default",
            },
            credentials: "include", */
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching partner list:", err);
        throw err;
    }
};
